import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { useAuth } from '../../../../../context/AuthContext';
import axios from "axios";
import Swal from 'sweetalert2'
import { API_BASE_URL } from "../../../../../Helpers/apiConfig";

export const CreateCoupenSingle = () => {
    const { t } = useTranslation()
    const { user } = useAuth();
    const [msg, setMsg] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [form, setForm] = useState({
        coupendescription: "",
        expiryDate: "",
        coupenpercentage: "",
        coupenusagelimit: ""
    });

    const handleChange = (e) => {
        const { id, value } = e.target;
        setForm((prev) => ({ ...prev, [id]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setMsg("");

        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = `${API_BASE_URL}/admin/Cupon/Create`;
            const res = await axios({
                method: 'Post',
                url: url,
                data: {
                    expiryDate: form.expiryDate,
                    percentage: Number(form.coupenpercentage),
                    usageLimit: Number(form.coupenusagelimit),
                    cuponDescription: form.coupendescription
                },
                headers: headerss
            });

            if (res.status === 200 && res.data['success']) {
                await Swal.fire({
                    title: "Başarılı!",
                    icon: "success",
                    confirmButtonText: `Tamam`
                });
                setForm({ coupendescription: "", expiryDate: "", coupenpercentage: "", coupenusagelimit: "" });
            } else {
                setMsg(res.data['message'] || "Beklenmedik bir hata oluştu.");
            }
        } catch (err) {
            setMsg(err?.message || "Beklenmedik bir hata oluştu.");
        }
        setSubmitting(false);
    }

    return (
        <div className="container-fluid py-3 py-md-4">
            <div className="row justify-content-center">
                <div className="col-12 col-lg-8 col-xl-6">
                    <div className="card shadow-sm border-0">
                        <div className="card-body p-3 p-md-4">
                            <div className="text-center mb-4">
                                <h1 className="h3 mb-1">{t('createsinglecode')}</h1>
                                <p className="text-muted mb-0">Tek kullanımlık ya da sınırlı kullanımlı tek bir kupon kodu oluşturun.</p>
                            </div>

                            {msg ? <div className="alert alert-danger">{msg}</div> : null}

                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="coupendescription" className="form-label">{t("coupendescription")}</label>
                                    <textarea
                                        className="form-control"
                                        id="coupendescription"
                                        value={form.coupendescription}
                                        onChange={handleChange}
                                        rows={3}
                                        required
                                    />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label" htmlFor="expiryDate">{t("coupenexpiryDate")}</label>
                                    <input
                                        type="datetime-local"
                                        className="form-control"
                                        id="expiryDate"
                                        value={form.expiryDate}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="row">
                                    <div className="col-12 col-md-6 mb-3">
                                        <label className="form-label" htmlFor="coupenpercentage">{t("coupenpercentage")}</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="coupenpercentage"
                                            value={form.coupenpercentage}
                                            onChange={handleChange}
                                            min="0"
                                            max="100"
                                            required
                                        />
                                    </div>

                                    <div className="col-12 col-md-6 mb-3">
                                        <label className="form-label" htmlFor="coupenusagelimit">{t("coupenusagelimit")}</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="coupenusagelimit"
                                            value={form.coupenusagelimit}
                                            onChange={handleChange}
                                            min="1"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="d-grid d-md-flex justify-content-md-center mt-4">
                                    <button type="submit" className="btn btn-primary btn-lg px-4" disabled={submitting}>
                                        {submitting ? "Oluşturuluyor..." : t('create')}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default CreateCoupenSingle;
